import React, { Component } from 'react';
import { BasicHeader } from '../../../components/basic_header';
import { RESTExecutor, withDomains } from '../../../lib/domain';
import { Spin, Button, Divider, Popconfirm, Table } from 'antd';
import ErrorWrapper from '../../../lib/error_wrapper';
import { PopUpForm } from '../../../lib/ui/popupform';
import { TransparentButton } from '../../../components/basic_items';
import { showErrorInNotification, formatMoney } from '../../../lib/util';

const queryString = require('query-string');


const extractors_cols = ({ onEditPressed, onDeletePressed }) => [
  {
    title: 'Expression',
    dataIndex: 'expression',
    className: 'word-break'
  },
  {
    title: 'Output Field',
    dataIndex: 'output_field'
  },
  {
    title: 'Type',
    dataIndex: 'type'
  },
  {
    title: "Action",
    dataIndex: "id",
    render: (id, data) => {
      return <span>
        <Button type='link' style={{ padding: 0 }} onClick={() => {
          typeof onEditPressed === 'function' && onEditPressed(data)
        }}>Edit</Button>
        <Divider type="vertical" />
        <Popconfirm title="Are you sure you want to delete?" onConfirm={() => {
          typeof onDeletePressed === 'function' && onDeletePressed(data.id)
        }}>
          <Button type='link' style={{ color: 'red', padding: 0 }}>Delete</Button></Popconfirm>
      </span>
    }
  }

]

const extractors_fields = [
  {
    name: 'Field Name',
    index: 'field',
    filterable: true,
    type: 'tagselect',
    options: []
  },
  {
    name: 'Expression',
    index: 'expression',
    type: 'text',
  },
  {
    name: 'Output Field',
    index: 'output_field',
    type: 'text',
  },
  {
    name: "Type",
    index: "type",
    type: 'select',
    options: [
      {
        text: "String",
        value: "string"
      },
      {
        text: "Integer",
        value: "integer"
      },
      {
        text: "Decimal",
        value: "decimal"
      },
      {
        text: "Date",
        value: "date"
      },
    ]

  },
]

class ServiceExtractors extends Component {
  constructor(props) {
    super(props)

    this.datatype_id = props.match.params.datatype_id;
    this.service_id = props.match.params.service_id;


    this.state = {
      filter_query: {

      },
      loading: true,
      modal_open: false,
      form_data: {
      },
      edit_id: null,
      schema: extractors_fields
    }

    this.datatype_detail = RESTExecutor.detail().config({
      label: 'data_types_detail',
    }).forId(this.datatype_id).callbacks((success) => {

      let datatype = success.result;
      this.fieldOptionAssigner(datatype.fields_config || [])

      this.list_extractors.config({
        params: {
          ...this.state.filter_query
        }
      }).execute();

      this.setState({ loading: false })

    }, (error) => {
      this.setState({ loading: false })

    }).connect(props.domains.datatype);

    this.list_extractors = RESTExecutor.list().config({
      label: 'service_extractors',
    }).forId(this.service_id).connect(props.domains.datatype);

    this.post_extractors = RESTExecutor.post().config({
      label: 'service_extractors'
    }).callbacks((success) => {
      this.setState({
        modal_open: false,
        form_data: {
        },
        edit_id: null,

      });
      this.list_extractors.execute();

    }).connect(props.domains.datatype);

    this.patch_extractors = RESTExecutor.patch().config({
      label: 'service_extractors_detail',
      params: {
        service_id: "",
        extractor_id: ""
      }
    }).callbacks((success) => {
      this.setState({
        modal_open: false,
        edit_id: null,
        form_data: {},

      });
      this.list_extractors.execute();

    }).connect(props.domains.datatype);


  }

  handlePostPatch = (data) => {

    if (this.state.edit_id) {
      // patch
      this.patch_extractors.config({
        params: {
          service_id: this.service_id,
          extractor_id: this.state.edit_id
        }
      }).execute(data);
    } else {
      this.post_extractors.forId(this.service_id).execute(data);
    }

  }
  delete = (id) => {

    RESTExecutor.delete().config({
      label: 'service_extractors_detail',
      params: {
        service_id: this.service_id,
        extractor_id: id
      }
    }).callbacks((success) => {
      this.list_extractors.execute();
    }, (error) => {
      showErrorInNotification(error);
    }).connect(this.props.domains.datatype).execute()
  }

  render() {
    if (this.state.loading) {
      return <center><Spin /></center>
    }
    let datatype_detail_resp = this.datatype_detail.response();
    let list_extractors_resp = this.list_extractors.response();
    let list_extractors_data = list_extractors_resp.result || {};
    let post_extractors_resp = this.post_extractors.response();
    let patch_extractors_resp = this.patch_extractors.response();

    // console.log(list_extractors_data)
    let rowsData = list_extractors_data.rows || [];
    let rowsMeta = list_extractors_resp.meta || {};


    return (

      <div>
        <ErrorWrapper error={datatype_detail_resp}
          onReload={() => {
            this.setState({ loading: true });
            this.datatype_detail.forId(this.datatype_id).execute();
          }}>
          <BasicHeader
            title="Service Extractors"
            right={[
              <TransparentButton
                label="Add New"
                className='cta-primary'
                hint="Add New Extractor"
                onClick={() => {
                  this.setState({
                    edit_id: null,
                    form_data: {},
                    modal_open: true,
                  })
                }}

              />
            ]}
          />

          <PopUpForm
            title="Extractor"
            width="50%"
            forCreate={this.state.edit_id
              ? false
              : true}
            initialData={this.state.form_data}
            fields={this.state.schema}
            open={this.state.modal_open}
            networkState={this.state.edit_id ? patch_extractors_resp : post_extractors_resp}
            onClose={() => this.setState({ modal_open: false })}
            onSubmit={(data) => {
              // console.log("DATA", data);
              this.handlePostPatch(data)
              // this.post_rules.execute(data);
            }}
          />

          <ErrorWrapper
            error={list_extractors_resp}
            onReload={() => {
              this.list_extractors.execute()
            }}
          >
            <div className='default-card' style={{
              padding: 0
            }}>
              <Table
                scroll={{ x: true }}
                className='main-table '
                loading={list_extractors_resp.fetching}
                size='small'

                pagination={{
                  simple: false,
                  position: 'bottom',
                  onChange: (current, size) => {
                    this.list_extractors.config({
                      params: {
                        per_page: size,
                        page: current,
                        service_rule_id: this.props.classifier_id
                      }
                    }).execute();
                  },
                  defaultCurrent: 1,
                  current: rowsMeta.pagination && parseInt(rowsMeta.pagination.split('/')[0]),
                  // defaultPageSize: 20,
                  pageSize: (rowsMeta && rowsMeta.requested_count),

                  total: (rowsMeta && rowsMeta.total_count),
                  showTotal: (total, range) => `${formatMoney(range[0], 0)}-${formatMoney(range[1], 0)} of ${formatMoney(total, 0)} items`
                }}
                // bordered={false}
                rowKey={(record) => record.id}
                columns={extractors_cols({
                  onEditPressed: (data) => {
                    this.setState({
                      edit_id: data.id,
                      form_data: data,
                      modal_open: true,
                      // schema:dynamic_field(this.onTypeChange,this.state.fieldOptions,data.extractor_type)
                    })
                  },

                  onDeletePressed: this.delete,
                })}
                dataSource={rowsData}

              />
            </div>
          </ErrorWrapper>

        </ErrorWrapper>
      </div>
    );
  }

  fieldOptionAssigner = (field_config = []) => {
    let schema = this.state.schema;
    var col_options = []
    field_config.map((configObj) => {
      // Object.keys(configObj).map((key) => {
      let config_item = configObj;
      // console.log("config item", config_item)

      // if (config_item.validation.type === 'string') {
      col_options.push({
        text: config_item.name,
        value: config_item.name
      });
      // }
      // })

    });
    col_options = [...col_options,
    ...[
      {
        value: "amount",
        text: 'amount',
      },
      {
        value: 'type',
        text: 'type',
      },
      {
        value: 'txn_date',
        text: 'txn_date',
        type: 'date'
      },
      {
        value: 'description',
        text: 'description',
        type: 'string'
      },
      {
        value: 'transaction_id',
        text: 'transaction_id',
        type: 'string'
      }
    ]
    ]

    schema.map((item) => {
      if (item.index === 'field') {
        item['options'] = col_options
      }
    });

    this.setState({
      schema: schema
    })

  }



  componentDidMount() {

    let new_filter_query = {};
    if (this.props.location && this.props.location.search) {
      const parsed = queryString.parse(this.props.location.search);
      new_filter_query = parsed;
    }
    this.setState({
      filter_query: {
        per_page: 100,
        page: 1,
        ...new_filter_query
      }
    }, () => {
      this.datatype_detail.execute()
      // this.list_packets.config({
      //     params: {
      //     ...this.state.filter_query
      //     }
      // }).execute()
    })
  }

  componentWillReceiveProps(nextProps) {
    var olddatatype_id = this.props.match.params.datatype_id;
    var newdatatype_id = nextProps.match.params.datatype_id;



    if (olddatatype_id !== newdatatype_id || (
      this.props.location && (this.props.location.search !== nextProps.location.search)
    )) {
      this.datatype_id = newdatatype_id;
      this.service_id = nextProps.match.params.service_id;

      const parsed = queryString.parse(nextProps.location.search);
      this.setState({
        filter_query: {
          per_page: 100,
          page: 1,
          ...parsed
        },
      }, () => {
        if (olddatatype_id !== newdatatype_id) {
          this.setState({
            loading: true
          }, () => {
            this.datatype_detail.forId(this.datatype_id).execute()
          })
        } else {
          this.list_extractors.forId(this.service_id).config({
            params: {
              ...this.state.filter_query
            }
          }).execute()
        }
      })

    }
  }
}

export default withDomains(ServiceExtractors, "datatype");
